<template>
  <section class="si-gateway" v-if="apiData !== null">
    <div class="si-gateway__control">
      <swisstopo-search
          outline
          :title="$t('searchTitle')" :placeholder="$t('searchText')"
          :cantons="cantons"
          v-model="place"
      />
    </div>
    <div class="si-gateway__control">
      <select-menu
          outline
          :title="$t('specializationsTitle')" :placeholder="$t('specializationsText')"
          :options="options('specializations')"
          v-model="specializations"
      />
    </div>
    <div class="si-gateway__control">
      <select-menu
          outline
          :title="$t('offeringsTitle')" :placeholder="$t('offeringsText')"
          :options="options('offerings')"
          v-model="offerings"
      />
    </div>
    <button type="button" class="si-gateway__submit" :title="$t('submit')" @click="submit"></button>
  </section>
</template>

<script>
import SelectMenu from './Fragments/SelectMenu.vue';
import SwisstopoSearch from './Fragments/SwisstopoSearch.vue';

export default {
  components: { SwisstopoSearch, SelectMenu },

  inject: ['baseUrl', 'locale'],

  data: () => ({
    place: null,
    specializations: [],
    offerings: [],

    apiData: null,
  }),

  computed: {
    cantons: (vm) => vm.apiData && vm.apiData['cantons'] || {},

    options () {
      return (field) => {
        const data = this.apiData[field] || {};

        return Object.keys(data).map((k) => ({
          value: Number(data[k].id),
          label: data[k].name,
        }));
      }
    },
  },

  methods: {
    submit () {
      const params = new URLSearchParams();

      if (this.offerings.length) {
        params.set('offerings', this.offerings.join(','));
      }

      if (this.place) {
        if (this.place.canton) {
          params.set('place', `${ this.place.label }|${ this.place.lat },${ this.place.lng }|${ this.place.canton }`);
        } else {
          params.set('place', `${ this.place.label }|${ this.place.lat },${ this.place.lng }`);
        }
      }

      if (this.specializations.length) {
        params.set('specializations', this.specializations.join(','));
      }

      location.href = `${ this.baseUrl }/#/?${ params.toString() }`;
    }
  },

  async mounted () {
    const response = await fetch(`${ this.baseUrl }/api/gateway?locale=${ this.locale }`);
    this.apiData = await response.json();
  }
}
</script>

<style lang="scss">
@import "../../styles/defaults";
@import "../../styles/layout";

.si-gateway {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &__control {
    width: 100%;
    flex-grow: 1;
  }

  &__submit {
    width: 60px;
    height: 60px;
    margin-top: 10px;
    background: url("../../images/submit.svg") 0 0/180px 60px no-repeat;
    border: none;
    cursor: pointer;

    &:hover {
      background-position: -60px 0;
    }

    &:active {
      background-position: -120px 0;
    }
  }

  .si-select-menu,
  .si-swisstopo-search {
    height: 60px;
    font-size: 17px;

    &__toggle,
    &__input {
      padding-left: 22px;
    }
  }
}

@include media(tablet, '.si-gateway') {
  &__submit {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    margin-top: 0;
    background-size: 240px 80px;

    &:hover {
      background-position: -80px 0;
    }

    &:active {
      background-position: -160px 0;
    }
  }

  .si-select-menu,
  .si-swisstopo-search {
    height: 80px;
    font-size: 19px;

    &__toggle,
    &__input {
      padding-left: 35px;
    }
  }
}

@include media(desktop, '.si-gateway') {
  flex-direction: row;
  gap: 20px;

  &__control {
    width: 33%;
  }
}
</style>
